import { render } from "./horizontal-header.vue?vue&type=template&id=04b67d58"
import script from "./horizontal-header.vue?vue&type=script&lang=js"
export * from "./horizontal-header.vue?vue&type=script&lang=js"

import "./horizontal-header.vue?vue&type=style&index=0&id=04b67d58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__